import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'
import Swal from 'sweetalert2'

export const projectRegister = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`project/${params.project_id}/register`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const projectKickOff = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`project/${params.project_id}/kickoff`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const projectApprove = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`project/${params.project_id}/approve`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const projectComplete = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`project/${params.project_id}/complete`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const projectReject = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`project/${params.project_id}/reject`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const projectHold = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`project/${params.project_id}/hold`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const projectUnHold = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`project/${params.project_id}/unhold`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const projectCancel = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`project/${params.project_id}/cancel`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const projectSkip = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`project/${params.project_id}/skip`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        Swal.fire({
          title: 'permission denied',
          icon: 'error',
          showConfirmButton: false,
          timer: 2500,
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        })
        const { response } = error
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
